import React, { useEffect, useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { addTreehouseChallenge, addTreehouseErrors } from '../../../constants/error.constants';
import LoadButton from '../../common/LoadButton';
import { SCHOOL_CHALLENGES } from '../../../constants/routes.constants';
import PartnerHeader from './PartnerHeader';
import { ErrorMessage } from '@hookform/error-message';
import { schoolViewModel } from './school.view.model';
import timezones from 'timezones-list';
import isURL from 'validator/lib/isURL';
import veryfiedIcon from '../../../assets/icon/verify-badge.svg';
import unVeryfiedIcon from '../../../assets/icon/Unverified.svg';
import { useAuth } from '../../auth/Auth';
import AddCaptainModal from './AddCaptainModal';
import defaultProfilePic from '../../../assets/profile/default-profile-guardian.svg';
import { useRecoilState } from 'recoil';
import { campTribesAtom } from '../../../atoms/camp.atom';

const CampAddTribe = () => {
  const _NOT_SELECTED = '';
  const history = useHistory();
  const { school } = useAuth();
  const pageRedirect = () => {
    history.goBack();
  };
  const [day, setDay] = useState('');
  const [age, setAge] = useState('');
  const [timezone, setTimezone] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isVirtual, setIsVirtual] = useState('no');
  const [campCaptainList, setCampCaptainList] = useState([]);
  const [selectedCampCaptain, setSelectedCampCaptain] = useState(null);
  const [campCaptainOptions, setCampCaptainOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [campTribes, setCampTribes] = useRecoilState(campTribesAtom);
  const { register, handleSubmit, setError, errors, getValues, clearErrors } =
    useForm({
      mode: 'onBlur',
    });

  const dayOptions = [
    { value: _NOT_SELECTED, label: 'Select...' },
    { value: 'sunday', label: 'Sunday' },
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
  ];

  const ageOptions = [
    { value: _NOT_SELECTED, label: 'Select...' },
    { value: 'A', label: 'Group A (8-12)' },
    { value: 'B', label: 'Group B (5-7)' },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const getCampCaptainsList = () => {
    const params = {
      limit: 99,
    };
    schoolViewModel.getCampCaptainsList(school?.id, params).then((res) => {
      setCampCaptainList(res);
      setCampCaptainOptions(
        res?.map((obj) => {
          return {
            value: obj?.id,
            label: (
              <div className="camp_captain_list-wrapper">
                <img
                  src={
                    obj?.profile?.picture_url
                      ? obj?.profile?.picture_url
                      : defaultProfilePic
                  }
                  className="camp_captain_list-img"
                />{' '}
                <p className="camp_captain_list">
                  {obj?.first_name} {obj?.last_name}{' '}
                  {obj?.user_type === 'school' ? '(Master)' : '(Captain)'}
                  <img
                    className="camp_captain_is_veryfied"
                    src={obj?.is_verified ? veryfiedIcon : unVeryfiedIcon}
                  />
                </p>
              </div>
            ),
          };
        })
      );
    });
  };

  useEffect(() => {
    getCampCaptainsList();
  }, []);

  const handleDayChange = (selected) => {
    setDay(selected.value);
  };

  const handleTimezoneChange = (selected) => {
    setTimezone(selected.tzCode);
  };

  const handleAgeChange = (selected) => {
    setAge(selected.value);
  };

  const onSubmit = handleSubmit((formData) => {
    setErrorMessage(null);
    setIsLoading(true);
    const params = getValues();
    let tempList = [];
    tempList.push(selectedCampCaptain);
    let body = {
      camp_captain_id: selectedCampCaptain,
      name: params['name'],
      day: params['day'],
      time: params['time'],
      timezone: params['timezone'],
      age_group: params['age'],
    };
    if (params['zoom_link']) {
      body.meet_link = params['zoom_link'];
    }
    schoolViewModel
      .addTribe(body)
      .then((res) => {
        setCampTribes([res, ...campTribes]); // Append
        history.push({
          pathname: SCHOOL_CHALLENGES,
          state: {
            from: 'add_treehouse',
            treehouseCode: res?.group_code,
            // treehouseCode: res.profile.camp_code
          },
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.serverResponse.error_info === 'Tribe name is already exits') {
          setErrorMessage('Tribe name is already exits');
        }
        if (err.serverResponse.result_code === 400034) {
          setErrorMessage('email', {
            type: 'manual',
            message: err.serverResponse.error_info,
          });
        }
        setIsLoading(false);
      });
  });

  const handleCampCaptainChange = (e) => {
    setSelectedCampCaptain(e.value);
  };

  const closeModal = () => setShowModal(!showModal);

  const handleComplete = (id) => {
    setSelectedCampCaptain(id);
    closeModal();
  };

  const checkTribeNameAvailability = (name) => {
    schoolViewModel
      .checkTribeNameAvailability(name)
      .then((res) => {
        clearErrors('name');
      })
      .catch((err) => {
        console.log(err);
        setError('name', {
          type: 'manual',
          message: err.serverResponse.error_info,
        });
      });
  };

  const handleNameChange = (e) => {
    if (e.target.value) {
      checkTribeNameAvailability(e.target.value);
    }
  };

  return (
    <div className="partner-wrapper-main">
      {showModal && (
        <AddCaptainModal
          show={showModal}
          closeModal={closeModal}
          getCampCaptainsList={getCampCaptainsList}
          handleComplete={handleComplete}
        />
      )}
      <PartnerHeader />
      <div className="add-more-branches partner_add_challenges">
        <span className="back-btn" onClick={pageRedirect}>
          <HiOutlineChevronLeft />
        </span>
        <Container>
          <div className="d-flex justify-content-center">
            <div className="a-challenge-partner">
              <h2 className="mb-60">Add a tribe</h2>
              <Form className="mt-50 mb-40" onSubmit={onSubmit}>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Your tribe</FormLabel>
                  <FormInput
                    name="name"
                    className="form-input"
                    data-testid="name"
                    ref={register({
                      required: addTreehouseErrors.name.required,
                    })}
                    placeholder="Enter tribe name"
                    onChange={handleNameChange}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="name"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Row className="new-dropdown">
                  <Form.Group className="mb-3 new-dropdown-col" controlId="">
                    <FormLabel>Camp Captain</FormLabel>
                    <Select
                      options={campCaptainOptions}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: '6px',
                        colors: {
                          ...theme.colors,
                          primary: '#80e4e1',
                        },
                      })}
                      onChange={handleCampCaptainChange}
                      value={
                        campCaptainOptions[
                          campCaptainOptions.findIndex(
                            (obj) => obj.value === selectedCampCaptain
                          )
                        ]
                      }
                    />
                    <input
                      type="hidden"
                      name="camp_captain"
                      value={selectedCampCaptain}
                      ref={register({
                        required: addTreehouseErrors.camp_captain.required,
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="camp_captain"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="">
                    <span
                      className="add-new-dropdown"
                      onClick={() => setShowModal(true)}
                    >
                      <Button className="gred-btn">+</Button>
                    </span>
                  </Form.Group>
                </Form.Row>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Age group</FormLabel>
                  <Select
                    options={ageOptions}
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleAgeChange}
                  />
                  <input
                    type="hidden"
                    name="age"
                    value={age}
                    ref={register({
                      required: addTreehouseErrors.age.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="age"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>
                    Choose a weekly time for your creative camp
                  </Form.Label>
                  <Select
                    options={dayOptions}
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleDayChange}
                  />
                  <FormInput
                    type="hidden"
                    name="day"
                    value={day}
                    ref={register({
                      required: addTreehouseErrors.day.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="day"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Time</FormLabel>
                  <FormInput
                    type="time"
                    name="time"
                    className="form-input"
                    ref={register({
                      required: addTreehouseErrors.time.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="time"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Time zone</Form.Label>
                  <Select
                    options={timezones}
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleTimezoneChange}
                  />
                  <input
                    type="hidden"
                    name="timezone"
                    value={timezone}
                    ref={register({
                      required: addTreehouseErrors.timezone.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="timezone"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Is your tribe virtual?</Form.Label>
                  <div key={`inline-radio`} className="mb-3">
                    <Form.Check
                      inline
                      label="Yes"
                      name="group1"
                      value="yes"
                      type="radio"
                      id={`inline-radio-1`}
                      onClick={() => setIsVirtual('yes')}
                    />
                    <Form.Check
                      inline
                      label="No"
                      value="no"
                      name="group1"
                      type="radio"
                      defaultChecked
                      onClick={() => setIsVirtual('no')}
                      id={`inline-radio-2`}
                    />
                  </div>
                </Form.Group>
                {isVirtual === 'yes' && (
                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>Meeting URL</FormLabel>
                    <FormInput
                      name="zoom_link"
                      className="form-input"
                      placeholder="Enter link to zoom / google meets"
                      data-testid="zoom_link"
                      ref={register({
                        validate: (input) =>
                          isURL(input) ||
                          addTreehouseChallenge.zoom_link.invalid,
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="zoom_link"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>
                )}
                <div
                  className="text-danger"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '-20px',
                  }}
                >
                  {errorMessage}
                </div>
                <Form.Group className="container-fluid">
                  <LoadButton
                    className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                    text="Create tribe"
                    isLoading={isLoading}
                    testid="submit"
                  />
                </Form.Group>
              </Form>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};
export default CampAddTribe;